import React, { createElement } from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
document.title = 'Swedenmark AI - Automation and Growth Consulting';
// Inject favicon dynamically
const svgFavicon = `
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
  <defs>
    <linearGradient id="g" x1="0%" y1="0%" x2="100%" y2="100%">
      <stop offset="0%" stop-color="#2563eb"/>
      <stop offset="100%" stop-color="#9333ea"/>
    </linearGradient>
  </defs>
  <rect width="32" height="32" rx="7" fill="url(#g)"/>
  <text x="16" y="21" font-family="Arial, sans-serif" font-size="13" font-weight="bold" fill="white" text-anchor="middle">AI</text>
</svg>`;
const blob = new Blob([svgFavicon], {
  type: 'image/svg+xml'
});
const url = URL.createObjectURL(blob);
const link = document.createElement('link');
link.rel = 'icon';
link.type = 'image/svg+xml';
link.href = url;
document.head.appendChild(link);
render(<App data-id="element-247" />, document.getElementById('root'));